import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, isRef as _isRef, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, withDefaults } from 'vue'

type PropsType = {
  modelValue: number | string | boolean
  label?: number | string | boolean
  name?: string
  text?: string
  disabled?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'SimpleRadioButton',
  props: {
    modelValue: { type: [Number, String, Boolean] },
    label: { type: [Number, String, Boolean] },
    name: null,
    text: { default: '' },
    disabled: { type: Boolean, default: false }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update:modelValue', value: number | string | boolean | undefined): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: number | string | boolean, label?: number | string | boolean, name?: string, text: string, disabled: boolean };





const selectedValue = computed({
  get: () => props.modelValue,
  set: (value) => {
    emit('update:modelValue', value)
  },
})

return (_ctx: any,_cache: any) => {
  const _component_el_radio = _resolveComponent("el-radio")!

  return (_openBlock(), _createBlock(_component_el_radio, {
    modelValue: _unref(selectedValue),
    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(selectedValue) ? (selectedValue).value = $event : null)),
    name: __props.name,
    label: __props.label,
    disabled: __props.disabled
  }, {
    default: _withCtx(() => [
      _createTextVNode(_toDisplayString(__props.text), 1)
    ]),
    _: 1
  }, 8, ["modelValue", "name", "label", "disabled"]))
}
}

})